/**
 * PDP metafield accordions: only one open at a time.
 */
(function () {
  function closeSiblings(current) {
    if (!current || current.getAttribute('data-aria-expanded') !== 'true') return;

    var scope = current.closest('.product__info') || current.closest('.product.product--page');
    if (!scope) return;

    scope.querySelectorAll('accordeon-component.product-content-tab--collapsible-row').forEach(function (item) {
      if (item === current) return;
      if (item.getAttribute('data-aria-expanded') !== 'true') return;
      if (typeof item.hide === 'function') {
        item.hide();
      } else {
        item.setAttribute('data-aria-expanded', 'false');
      }
    });
  }

  function onAccordeonActivate(event) {
    var button = event.target.closest(
      '.product.product--page accordeon-component.product-content-tab--collapsible-row accordeon-button'
    );
    if (!button) return;

    // Theme toggles in the same event; run after that handler.
    requestAnimationFrame(function () {
      closeSiblings(button.closest('accordeon-component'));
    });
  }

  document.addEventListener('click', onAccordeonActivate);
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.keyCode !== 13) return;
    onAccordeonActivate(event);
  });
})();

/**
 * PDP size chart modal (<dialog>)
 */
(function () {
  function closestDialogFromTrigger(trigger) {
    var root = trigger.closest('.tabela-de-medidas');
    if (!root) return null;
    return root.querySelector('dialog.tabela-de-medidas__dialog');
  }

  document.addEventListener('click', function (event) {
    var openBtn = event.target.closest('[data-size-chart-open]');
    if (openBtn) {
      var dialog = closestDialogFromTrigger(openBtn);
      if (dialog && typeof dialog.showModal === 'function') {
        dialog.showModal();
      }
      return;
    }

    var closeBtn = event.target.closest('[data-size-chart-close]');
    if (closeBtn) {
      var d = closeBtn.closest('dialog');
      if (d && typeof d.close === 'function') d.close();
      return;
    }
  });

  document.addEventListener('click', function (event) {
    var dialog = event.target;
    if (!(dialog instanceof HTMLDialogElement)) return;
    if (!dialog.classList.contains('tabela-de-medidas__dialog')) return;
    // Clique no backdrop: target === dialog
    if (event.target === dialog) {
      dialog.close();
    }
  });
})();
